import AssetHelper from "ftc-common/AssetHelper";
import { FllScoreCalculator } from "./FllScoreCalculator";
import { createRoot } from "react-dom/client";

/*
 * Served at /fll/score-calculator — no authentication required.
 */
AssetHelper.ensureProperties().then(() => {
    const container = document.createElement("div");
        container.id = "reactContainer";
        document.body.innerHTML = "";
        document.body.appendChild(container);

        const root = createRoot(container);
        root.render(<FllScoreCalculator />);
});

